






































import { defineComponent, ref } from '@vue/composition-api';
import { MarkerType } from '../../types';
// import { MarkerProps } from '../../types'

export default defineComponent({
  name: 'MarkerSymbols',
  props: {
    id: String,
    type: String,
    width: {
      type: Number,
      default: 12.5
    },
    height: {
      type: Number,
      default: 12.5
    },
    markerUnits: {
      type: String,
      default: 'strokeWidth'
    },
    orient: {
      type: String,
      default: 'auto-start-reverse'
    },
    strokeWidth: {
      type: Number,
      default: 1
    },
    color: {
      type: String,
      default: 'none'
    }
  },

  setup(props) {
    return {
      MarkerType: ref(MarkerType)
    };
  }
});
